module.exports = __webpack_public_path__ + "img/corp__intro.ca31fd63.png";